import React from 'react'

import View from '../../../../../components/pdf/View'
import Text from '../../../../../components/pdf/Text'
import Separator from '../../../../../components/pdf/Separator'
import { Table, TableRow } from '../../../../../components/pdf/Table'
import { TableColLabelValue, TableColText, TableHeadText } from '../../../../../components/pdf/TableHelpers'
import {
  findReplyByQuestionId,
  getReplyValue,
  getRepliesFromBlockQuestion,
  toCurrency,
  getComplexReplyValue,
  toDateFormat,
  filterRepliesByParentReference
} from '../../_helpers/pdfHelpers'
import { useServiceOrder } from '../../_load/ServiceOrderLoader'
import { useMemo } from 'react'

const Content = ({ templateId }) => {
  const { replies } = useServiceOrder()

  const name = getComplexReplyValue(findReplyByQuestionId(replies, 1731), ['name'])
  const cpf = getReplyValue(findReplyByQuestionId(replies, 1743))
  const traffitTicket = getReplyValue(findReplyByQuestionId(replies, 1737))
  const traffitTicketWrittenFull = getReplyValue(findReplyByQuestionId(replies, 1744))
  const hasInstallments = getReplyValue(findReplyByQuestionId(replies, 1738))
  const totalInstallments = getReplyValue(findReplyByQuestionId(replies, 1739))
  const plate = getComplexReplyValue(findReplyByQuestionId(replies, 1742), ['name'])
  const date = toDateFormat(getReplyValue(findReplyByQuestionId(replies, 1735)), 'DD/MM/YYYY')
  const hour = toDateFormat(getReplyValue(findReplyByQuestionId(replies, 1735)), 'HH:mm')
  const description = getReplyValue(findReplyByQuestionId(replies, 1745))

  const tickets = () => {
    const mainAssetReply = findReplyByQuestionId(replies, 1746)
    const installments = filterRepliesByParentReference(replies, mainAssetReply.question.reference)
    const installmentsResult = {}
    installments.forEach(installment => {
      const blockIndex = installment.blockIndex
      let installMentData = installmentsResult[blockIndex]
      if (!installMentData) {
        const blockReplies = getRepliesFromBlockQuestion(installments, blockIndex)
        installMentData = {
          installment: getReplyValue(findReplyByQuestionId(blockReplies, 1747)),
          cod: getReplyValue(findReplyByQuestionId(blockReplies, 1748)),
          description: getReplyValue(findReplyByQuestionId(blockReplies, 1749)),
          value: getReplyValue(findReplyByQuestionId(blockReplies, 1750)),
          date: getReplyValue(findReplyByQuestionId(blockReplies, 1751))
        }
        installmentsResult[blockIndex] = installMentData
      }
    })
    return Object.values(installmentsResult)
  }

  const tembiciData = useMemo(() => {
    if (templateId === 4) {
      return {
        name: 'M2 Soluçoes em Engenharia LTDA',
        cnpj: '13.051.498/0001-63'
      }
    }
    return {
      name: 'M1 Transporte sustentável LTDA',
      cnpj: '14.192.913/0011-33'
    }
  }, [templateId])

  const textDescription = () => {
    if (hasInstallments) {
      return (
        <>
          Eu, {name}, portador do CPF: {cpf} , autorizo a <b> {tembiciData.name}.</b> V, CNPJ:
          {tembiciData.cnpj} a realizar o desconto de{' '}
          <b>
            {toCurrency(traffitTicket)} ({traffitTicketWrittenFull}),
          </b>{' '}
          em folha de pagamento em <b>{totalInstallments} parcelas,</b> referente a uma infração de trânsito com o
          veículo de placa <b>{plate}</b> em <b>{date}</b> às <b>{hour}.</b> {description}
        </>
      )
    }
    return (
      <>
        Eu, {name} , portador do CPF: {cpf} , autorizo a <b>{tembiciData.name}.</b> V, CNPJ:
        {tembiciData.cnpj} a realizar o desconto de{' '}
        <b>
          {toCurrency(traffitTicket)} ({traffitTicketWrittenFull}),
        </b>{' '}
        em folha de pagamento em <b>1 parcela,</b> referente a uma infração de trânsito com o veículo de placa{' '}
        <b>{plate}</b> em <b>{date}</b> às <b>{hour}.</b> {description}
      </>
    )
  }

  return (
    <View pageBreakAfter>
      <Text style={{ lineHeight: 2 }}>{textDescription()}</Text>
      <Separator weight={4} />
      {hasInstallments ? (
        <Table justify="space-between" width={'100%'} style={{ pageBreakInside: 'auto' }}>
          <TableRow>
            <TableHeadText align="center">PARCELA</TableHeadText>
            <TableHeadText align="center">CÓDIGO FOLHA</TableHeadText>
            <TableHeadText align="center">DESCRIÇÃO</TableHeadText>
            <TableHeadText align="center">VALOR</TableHeadText>
            <TableHeadText align="center">DATA</TableHeadText>
          </TableRow>
          {tickets().map((row, rowIndex) => (
            <TableRow key={rowIndex}>
              <TableColText align="center">{row.installment}</TableColText>
              <TableColText align="center">{row.cod}</TableColText>
              <TableColText align="center">{row.description}</TableColText>
              <TableColText align="center">{toCurrency(row.value)}</TableColText>
              <TableColText align="center">{toDateFormat(row.date, 'DD/MM/YYYY')}</TableColText>
            </TableRow>
          ))}
        </Table>
      ) : (
        <Table justify="space-between" width={'100%'}>
          <TableRow>
            <TableHeadText align="center">PARCELA</TableHeadText>
            <TableHeadText align="center">CÓDIGO FOLHA</TableHeadText>
            <TableHeadText align="center">DESCRIÇÃO</TableHeadText>
            <TableHeadText align="center">VALOR</TableHeadText>
            <TableHeadText align="center">DATA</TableHeadText>
          </TableRow>
          <TableRow key={1}>
            <TableColText align="center">1</TableColText>
            <TableColText align="center">-</TableColText>
            <TableColText align="center">{description}</TableColText>
            <TableColText align="center">{toCurrency(traffitTicket)}</TableColText>
            <TableColText align="center">
              {date} {hour}
            </TableColText>
          </TableRow>
        </Table>
      )}

      <Separator weight={50} />

      <Table justify="space-between" width={'50%'} center style={{ border: 'none' }}>
        <TableRow style={{ border: '1px solid black' }} />
        <TableRow style={{ border: 'none' }} align="center">
          <TableColLabelValue label={'Nome'} value={name} style={{ border: 'none' }} />
        </TableRow>
        <TableRow style={{ border: 'none' }} align="center">
          <TableColLabelValue label={'CPF'} value={cpf} style={{ border: 'none' }} />
        </TableRow>
      </Table>
    </View>
  )
}

export default Content
